import { Buffer } from 'buffer';
if (typeof window !== 'undefined' && window.Buffer === undefined) {
    window.Buffer = Buffer;
}
//# sourceMappingURL=Buffer.js.map